<script setup lang="ts">
import type { AppBannerOutline, AppBannerType } from './AppBanner.model';

export interface AppBannerProps {
  type: AppBannerType;
  title?: string;
  subtitle?: string;
  color: AppBannerOutline;
}

const props = defineProps<AppBannerProps>();
</script>

<template>
  <div :class="['app-banner', [props.type], `${props.color}-outline`]">
    <slot name="left-icon" />
    <div class="text-wrapper">
      <span v-if="props.title" class="info-title">
        {{ props.title }}
      </span>
      <span v-if="props.subtitle" class="info-subtitle">
        {{ props.subtitle }}
      </span>
    </div>
    <slot name="right-icon" />
  </div>
</template>

<style scoped lang="scss">
@import '../../styles/_media.scss';
@import '../../styles/_fonts.scss';

.app-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--spacing-12);

  padding: var(--spacing-12);
  border-radius: var(--border-radius-8);
  cursor: pointer;
  transition: background-color var(--transition-short);
  background: var(--color-white);

  &.grey-outline {
    border: 1px dashed var(--color-neutral-50);
  }

  &.purple-outline {
    border: 3px dashed var(--color-sembo-purple);
  }

  &.secondary {
    @include on-hover {
      background-color: var(--color-neutral-30);
      border-color: transparent;
    }
  }

  .text-wrapper {
    display: flex;
    flex-direction: column;
    color: var(--color-soft-black);
    gap: var(--spacing-8);

    .info-title {
      @include font-label-s-bold;
    }

    .info-subtitle {
      @include font-body-s-light;
      color: var(--color-neutral-70);
    }
  }
}
</style>
